function DelayUpdater(ref) {
	this.ref = ref;

	this._bucket = {};
	this._startTimerUpdate = {};
	this._process = {};
	
	done = () => {
		// Keep idea
	}
};

DelayUpdater.prototype.bucket = function(dataKey="root") {
	return this._bucket[dataKey];
}

DelayUpdater.prototype.addToBucket = function(dataName, dataValue, idx) {
	const state = this.ref.state;
	let hasState = state[dataName] ? state[dataName] : state.data[dataName];
	
	let dataKey = "root";

	if (Array.isArray(hasState)) {
		if (this._bucket[dataName]) {
			// exists bucket
		} else {
			this._bucket[dataName] = [];
			this._process[dataName] = [];
		}

		if(this._bucket[dataName][idx] === undefined) {
			this._bucket[dataName][idx] = {}
		}
		
		for(var e in dataValue) {
			this._bucket[dataName][idx][e] = dataValue[e];
		}

		dataKey = dataName
	} else {
		if( ! this._bucket[dataKey]) this._bucket[dataKey] = {};
		this._bucket[dataKey][dataName] = dataValue;
	}

	return this._bucket;
}

DelayUpdater.prototype.update = function(dataName, dataValue, handleUpdate, idx) {
	const state = this.ref.state;
	let hasState = state[dataName] ? state[dataName] : state.data[dataName];
	
	// Validate Data Value
	if(hasState instanceof Array) {
		if(dataValue instanceof Object) {
			// Valid Data Valud
		} else {
			console.info('Data value : ', dataValue)
			console.error(`Data value must be object for '${dataName}' element.`)
			return;
		}
	}

	let isArrayProperty = false;
	let timerKey = "root";
	let dataKey = "root";

	if (Array.isArray(hasState)) {
		if (this._bucket[dataName]) {
			// exists bucket
		} else {
			this._bucket[dataName] = [];
			this._process[dataName] = [];
		}

		if(this._bucket[dataName][idx] === undefined) {
			this._bucket[dataName][idx] = {}
		}
		
		for(var e in dataValue) {
			this._bucket[dataName][idx][e] = dataValue[e];
		}

		this._process[dataName][idx] = "SAVE";

		isArrayProperty = true
		timerKey = `${dataName}-${idx}`
		dataKey = dataName
	} else {
		if( ! this._bucket[dataKey]) this._bucket[dataKey] = {};
		this._bucket[dataKey][dataName] = dataValue;
		this._process[dataKey] = "SAVE"
	}

	clearTimeout(this._startTimerUpdate[timerKey]);
	// console.info('Start Delay Update ...');
	this._startTimerUpdate[timerKey] = setTimeout(async () => {
		let response = await handleUpdate(this._bucket[dataKey], idx);

		// console.info("Response : ", response);
		if(response === undefined) {
			console.warn("Response must be send back to updater");
			this._bucket[dataKey] = undefined;
		} else if(response.result.match(/ok/i)) {
			this._bucket[dataKey] = undefined;
		}

		this._startTimerUpdate[timerKey] = undefined;
		// console.info('Delayed Update Done');

	}, 1250);        
}

module.exports = DelayUpdater